export const xScale = 0.5; // vw for each unit in x direction
export const yScale = 2; // vh for each unit in y direction
export const neededParticipants = 2;